import { useQuery } from '@tanstack/react-query'
import { getOpportunity } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

interface UseOpportunityOptions {
  enabled?: boolean
}

/**
 * オポチュニティ詳細を取得するカスタムフック
 *
 * @param opportunityId - オポチュニティID
 * @param options - フックオプション
 * @returns TanStack Query の結果
 */
export function useOpportunity(opportunityId: number, options: UseOpportunityOptions = {}) {
  const { enabled = true } = options

  return useQuery({
    queryKey: queryKeys.opportunity.detail(opportunityId),
    queryFn: async () => {
      return getOpportunity(opportunityId)
    },
    enabled: enabled && opportunityId > 0,
  })
}
